<template>
  <Layout>
    <b-row class="d-flex" lg="12">
      <b-col lg="10" md="9"><PageHeader :title="title" :items="items" class="mt-2"/></b-col>
      <b-col lg="2" class="pb-4"><b-button variant="primary" size="lg" href="/source/add-source" class="float-end">Ajouter une source</b-button></b-col>
    </b-row>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table align-middle table-nowrap table-hover">
                <thead class="table-light">
                <tr>
                  <th scope="col">Nom</th>
                  <th scope="col">Url</th>
                  <th scope="col">État</th>
                  <th scope="col">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="list in listSource" :key="list.id">
                  <td>
                    <h5 class="font-size-14 mb-1">
                      <a :href="'/source/' + list.id + '/edit-source'" class="text-dark"
                      > {{ list.name }} </a>
                    </h5>
                  </td>
                  <td>{{ list.url }}</td>
                  <td>
                    <span v-html="(list.state) ?'Active':'Non Active'"
                          :class="(list.state) ?'badge bg-success':'badge bg-danger '"
                    ></span>
                  </td>
                  <td>
                    <ul class="list-inline font-size-20 contact-links mb-0">
                      <li class="list-inline-item px-2">
                        <a :href="'/source/' + list.id + '/edit-source'">
                          <i
                              v-b-tooltip.hover
                              title="Modifier"
                              class="bx bx-edit-alt pointer mr-2 color-edit"
                          >
                          </i>
                        </a>
                      </li>
                      <li class="list-inline-item px-2">
                        <i
                            v-b-tooltip.hover
                            title="Supprimer"
                            class="bx bx-trash-alt pointer color-delete my-3"
                            @click="confirmDeleteSource(list)"
                        >
                        </i>
                      </li>
                    </ul>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";

/**
 * Users component
 */
export default {
  name:'source',
  page: {
    title: "SOURCES",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, PageHeader},
  data() {
    return {
      title: "SOURCES",
      items: [],
      currentPage: 1,
      totalPages: 0,
      baseURL: process.env.API_URL,
    };
  },
  created() {
    this.getlistSource();
  },
  methods: {
    getlistSource() {
      this.$store.dispatch("source/listSource");
    },
    movePages(p) {
      if (p !== this.currentPage) {
        this.currentPage = p;
        this.getlistSource();
      }
    },
    confirmDeleteSource(element) {
      this.showAlert({
        title: "Vous êtes sûr ?",
        text: "Vous ne pourrez pas revenir en arrière !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b1215c",
        confirmButtonText: "Oui, supprimez-le !",
        cancelButtonText: "Annuler",
        confirmType: {
          type: "deleteSource",
          id: element.id,
        },
      });
    },
    /* delete source  */
    deleteSource(id) {
      this.$store.dispatch("source/deleteSource", id).then(
          (res) => {
            this.showAlert({
              icon: "success",
              title: "Supprimé!",
              text: "La source a été supprimée avec succès",
              confirmType: {
                type: "refreshSource",
              },
            });
          },
          (err) => {
            this.showAlert({
              icon: "error",
              title: "Non supprimée!",
              text: "Echec de suppression source",
            });
          }
      );
    },
    /* Alerts */
    showAlert(data) {
      Swal.fire({
        icon: data.icon,
        title: data.title,
        text: data.text,
        confirmButtonColor: "#b1215c",
        showCancelButton: data.showCancelButton,
        confirmButtonText: data.confirmButtonText
            ? data.confirmButtonText
            : "OK",
        cancelButtonText: data.cancelButtonText,
      }).then((res) => {
        if (data.confirmType) {
          if (data.confirmType.type === "deleteSource") {
            if (res.isConfirmed) this.deleteSource(data.confirmType.id);
          }
          if (data.confirmType.type === "refreshSource") {
            this.getlistSource();
          }
        }
      });
    },
  },
  computed: {
    listSource() {
      return this.$store.getters["source/getSource"];
    },
  },
};
</script>

<style scoped>
h5 a{
  color: #495057 !important;
}
</style>
